export const Styles = {
    listItemBox: { marginBottom: '15px', marginTop: '0px' },
};
